import Input from "../shared/Input";
import Button from "../shared/Button";
import { toast } from "react-toastify";

export default function ProjectDiscount({
  projectDiscount,
  registerProjectDiscount,
  closeDiscount,
  salesOfficeMargin,
  setProjectDiscount,
  setSalesOfficeMargin,
  updateProjectDiscounts,
  discountLimit,
  lockDiscount = false,
}) {
  const onApplyProjectDiscounts = () => {
    if (lockDiscount) {
      toast("Remove line item discounts before applying a project discount");
      return;
    }
    if (discountLimit != 0 && projectDiscount > discountLimit) {
      toast("Discount not allowed");
      return;
    }
    updateProjectDiscounts({
      projectDiscount: projectDiscount,
      salesMargin: salesOfficeMargin,
    });
    closeDiscount();
  };

  return (
    <div className="grid gap-2">
      <Input
        elementtype="input"
        label="Project Discount"
        name="projectDiscount"
        id="projectDiscount"
        type="number"
        placeholder="0.00"
        value={projectDiscount}
        onChange={(e) => setProjectDiscount(e.target.value)}
        disabled={lockDiscount}
        title={lockDiscount ? "Locked: line item discounts are applied" : undefined}
      />
      {lockDiscount && (
        <p className="text-xs text-amber-600">
          Project discount locked: Remove line-item discounts first.
        </p>
      )}
      <Input
        elementtype="input"
        label="Sales Office Margin (%)"
        name="salesOfficeMargin"
        id="salesOfficeMargin"
        type="number"
        placeholder="0.00"
        value={salesOfficeMargin}
        onChange={(e) => setSalesOfficeMargin(e.target.value)}
      />
      <div className="flex flex-row gap-2">
        <Button
          text="Apply"
          buttoncolor="primary"
          buttonSize="xs"
          onClick={onApplyProjectDiscounts}
          disabled={lockDiscount}
        ></Button>
        <Button
          text="Cancel"
          buttoncolor="disabled"
          buttonSize="xs"
          onClick={closeDiscount}
        ></Button>
      </div>
    </div>
  );
}